/* eslint-disable max-lines */
/* eslint-disable quotes */
/* eslint-disable quote-props */
/* eslint-disable max-lines-per-function */
import FormCardItemComponent from './form_card_item';
import { FormObject } from '../../params/redux/form';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { Box, Grid } from '@mui/material';

const FormCardComponent = ({ searched, sort }: { searched: string, sort: boolean }) => {
    const { forms, assignedForms } = useSelector((state: RootState) => state.form);
    const filteredForms = [...forms, ...assignedForms]
        .filter((form: FormObject) => {
            const title = (form.title || '').trim().toLowerCase();
            const { status } = form;
            return (
                form.type !== 'snapps' &&
                form.type !== 'elementor' &&
                form.type !== 'custom' &&
                (title.includes(searched.toLowerCase()) ||
                    status.toLowerCase().includes(searched.toLowerCase()))
            );
        });
    const sortedForms: FormObject[] = sort
        ? [...filteredForms].sort((a, b) => a.title.localeCompare(b.title))
        : filteredForms;

    return <Box height="60vh" width="100%" mt={2}>
        <Grid container spacing={2}>
            {
                sortedForms.map((form, index) => <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={index}>
                    <FormCardItemComponent form={form as unknown as FormObject} />
                </Grid>)
            }
        </Grid>
    </Box>;
};

export default FormCardComponent;